import React from "react";

function cta(){
    return (
      <section id="cta">
        <h3 class="last-h3">Find the True Love of Pastries Today.</h3>
        <button type="button" class="btn btn-dark btn-lg download-button">
          <i class="fa-brands fa-apple"></i> Download
        </button>
        <button
          type="button"
          class="btn btn-outline-light btn-lg download-button"
        >
          <i class="fa-brands fa-google-play"></i> Download
        </button>
      </section>
    );
}
export default cta;